// extracted by mini-css-extract-plugin
export default {"root":"List_root__TnYIP","item":"List_item__BMC-m","customEmpty":"List_customEmpty__mplW2"};